


















import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Icon from '@/components/Icon.vue'
import 'vue2-datepicker/index.css'
import moment from 'moment/moment'

const Datepicker = require('vue2-datepicker').default

@Component({
  props: {
    value: {
      type: [String, Date]
    },
    label: {
      type: String
    },
    validation: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'date'
    },
    error: {
      default: false,
      type: Boolean
    },
    dateTo: {
      type: Date
    },
    dateFrom: {
      type: Date
    },
    fixedPopover: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Icon,
    Datepicker
  }
})
export default class DateInput2 extends Vue {
  isError: boolean = false
  date: Date | string = ''

  emitInput (value: Date | string) {
    if (this.$props.validation === 'required' && !value) {
      this.isError = true
    } else if (value) {
      this.isError = false
    }
    this.$emit('input', value)
  }

  focusout () {
    this.emitInput(this.date)
    this.$emit('focusout')
  }

  getFormat () {
    switch (this.$props.type) {
      case 'datetime':
        return 'MM/DD/YYYY HH:mm'
      default:
        return 'MM/DD/YYYY'
    }
  }

  initDate (newValue?: string) {
    const value = newValue || this.$props.value
    this.date = value ? moment(value).format(this.getFormat()) : ''
  }

  mounted () {
    if (this.$props.fixedPopover) {
      const datePicker = (this.$refs.datepicker as Vue).$refs.popup as Vue
      const el = datePicker.$el;
      (this.$refs.target as Element).appendChild(el)
    }
    this.initDate()
    this.$watch('value', (newVal: any) => {
      this.emitInput(newVal)
      this.initDate(newVal)
    }, { deep: true })
  }

  isDisabledDate (date: Date) {
    return date < this.$props.dateFrom || date > this.$props.dateTo
  }
}
